import { render } from "./Transition.vue?vue&type=template&id=50c6e9f9"
import script from "./Transition.vue?vue&type=script&lang=js"
export * from "./Transition.vue?vue&type=script&lang=js"
script.render = render

export default script